import React, { useState, useContext } from 'react'
import { AuthContext } from '../../context/AuthContext'
import { submitConsent } from '../../service/consentService'
import StudyConsentModal from './StudyConsentModal'

// Consent, leading the main session — the first block a participant does unproctored,
// so it can't be taken verbally on the screening call.
//
// Uses the same consent ENDPOINT as /workspace (participants have a real user row and
// session row, so their consent lands in the same table as everyone else's) but its own
// FORM: this study records screen and camera, which the classroom form explicitly
// promises it does not do. See StudyConsentModal.
export default function ConsentStep ({ step, participantId, onAdvance, busy }) {
  const { currentUser } = useContext(AuthContext)
  const [declined, setDeclined] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState('')

  const handleConsent = async (didConsent) => {
    setProcessing(true)
    setError('')
    try {
      // Best-effort persistence: a consent record that fails to save must not trap a
      // participant who has just agreed, so the decision is also carried forward in
      // the step payload, which the engine stores against the participant either way.
      if (currentUser?.id && step?.dbSessionId) {
        await submitConsent(currentUser.id, step.dbSessionId, didConsent)
      }
    } catch (e) {
      console.warn('Consent save failed, continuing with in-study record:', e.message)
    } finally {
      setProcessing(false)
    }

    if (!didConsent) { setDeclined(true); return }
    onAdvance({ consented: true, at: Date.now() })
  }

  if (declined) {
    return (
      <div className="study-card study-done">
        <h2 className="study-h2">Thank you for your time</h2>
        <p>
          You’ve declined to take part, so we won’t collect anything further and your
          session ends here. Nothing you did today will be used in the research.
        </p>
        <p className="study-hint">
          If you declined by mistake, contact the research team and we can reopen your link.
        </p>
      </div>
    )
  }

  return (
    <>
      <StudyConsentModal onConsent={handleConsent} isProcessing={processing || busy} />
      {error && <p className="study-err">{error}</p>}
    </>
  )
}
